/**
 * Expenses API Service
 *
 * Handles all expense-related API calls:
 * - Get expenses
 * - Get expense types
 * - Add expense
 * - Delete expense
 */

import { post, get } from './client';

export const expensesApi = {
    /**
     * Get all expenses for a landlord
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} List of expenses
     */
    getAll: async (landlordId) => {
        return post('pegasus/visionary/expenses/', {
            landlord_id: landlordId,
        });
    },

    /**
     * Get all expense types
     * @returns {Promise<Object>} List of expense types
     */
    getTypes: async () => {
        return get('pegasus/visionary/expenseTypes/', {
            requiresAuth: false,
        });
    },

    /**
     * Add a new expense
     * @param {Object} expenseData
     * @param {string} expenseData.description - Expense description
     * @param {string} expenseData.property_id - Property ID
     * @param {string} expenseData.expense_type - Expense type
     * @param {string} expenseData.house_number - Optional house number
     * @param {number} expenseData.cost - Expense cost
     * @param {string} expenseData.landlord_id - Landlord ID
     * @param {number} expenseData.year - Year
     * @param {number} expenseData.month - Month
     * @param {number} expenseData.day - Day
     * @returns {Promise<Object>} Add expense response
     */
    add: async (expenseData) => {
        return post('pegasus/visionary/expenses/add', expenseData);
    },

    /**
     * Delete an expense
     * @param {string} expenseId - Expense ID to delete
     * @returns {Promise<Object>} Delete response
     */
    delete: async (expenseId) => {
        return post('pegasus/visionary/expenses/delete', {
            expense_id: expenseId,
        });
    },
};

export default expensesApi;
